import React, { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { ALIGN, InfoBox, useDevice } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";

interface RefundBannerProps {
  readonly style?: StyleProp<ViewStyle>;
}

const RefundBanner: FC<RefundBannerProps> = ({ style: customStyle }) => {
  const { screen } = useDevice();

  const orderReturnMessageFirstText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_RETURN_MESSAGE_FIRST,
  });
  const orderReturnMessageSecondText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_RETURN_MESSAGE_SECOND,
  });

  return (
    <InfoBox
      contentAlign={screen.L ? ALIGN.CENTER : undefined}
      style={customStyle}
      text={`${orderReturnMessageFirstText} ${orderReturnMessageSecondText}`}
    />
  );
};

export { RefundBanner };
